// Shared scale helpers for psychometric tests

// Helper for STAI Direct Scoring (1-4)
export const staiDirect = [
  {label: 'Casi nunca', value: 1},
  {label: 'A veces', value: 2},
  {label: 'A menudo', value: 3},
  {label: 'Casi siempre', value: 4}
];

// Helper for STAI Reverse Scoring (4-1)
export const staiReverse = [
  {label: 'Casi nunca', value: 4},
  {label: 'A veces', value: 3},
  {label: 'A menudo', value: 2},
  {label: 'Casi siempre', value: 1}
];

// Helper for YMRS Normal (0-4)
export const ymrsNormal = [
  {label: 'Ausente', value: 0},
  {label: 'Leve', value: 1},
  {label: 'Moderado', value: 2},
  {label: 'Marcado', value: 3},
  {label: 'Severo', value: 4}
];

// Helper for YMRS Double Weight (0-8)
export const ymrsDouble = [
  {label: 'Ausente', value: 0},
  {label: 'Leve', value: 2},
  {label: 'Moderado', value: 4},
  {label: 'Marcado', value: 6},
  {label: 'Severo', value: 8}
];

// Helper for BSSI (0-2)
export const bssiScale = (opt0: string, opt1: string, opt2: string) => [
  {label: opt0, value: 0},
  {label: opt1, value: 1},
  {label: opt2, value: 2}
];

// Generic Likert scales
export const likert0to3 = [
  {label: 'Nunca', value: 0},
  {label: 'Varios días', value: 1},
  {label: 'Más de la mitad de los días', value: 2},
  {label: 'Casi todos los días', value: 3}
];

export const likert0to4 = [
  {label: 'Nada', value: 0},
  {label: 'Levemente', value: 1},
  {label: 'Moderadamente', value: 2},
  {label: 'Severamente', value: 3},
  {label: 'Extremadamente', value: 4}
];
